module.exports = __webpack_public_path__ + "img/17.d9c62bd8.png";